import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { buildAgentSessionRequestConfig } from "./agentApiSession";

const WHITE_LABEL_DOMAIN_PATH = "/api/agent/white-label-domain";

function whiteLabelDomainUrl() {
  return resolveApiUrl(WHITE_LABEL_DOMAIN_PATH);
}

export async function fetchAgentWhiteLabelDomain() {
  const cfg = await buildAgentSessionRequestConfig();
  const { data } = await axios.get(whiteLabelDomainUrl(), cfg);
  return data;
}

export async function submitAgentWhiteLabelDomain(customDomain) {
  const cfg = await buildAgentSessionRequestConfig();
  const { data } = await axios.put(
    whiteLabelDomainUrl(),
    {
      custom_domain: String(customDomain || "").trim(),
      sessionID: cfg.sid,
    },
    cfg
  );
  return data;
}

export async function deleteAgentWhiteLabelDomainRequest() {
  const cfg = await buildAgentSessionRequestConfig();
  const { data } = await axios.delete(whiteLabelDomainUrl(), {
    ...cfg,
    data: { sessionID: cfg.sid },
  });
  return data;
}
